module.exports = __webpack_public_path__ + "static/media/HoleWall.51e9161c.svg";